import React from 'react';
import moment from 'moment';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/users/admins';

const ListAdmins = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { email: 1 },
      cols: [
        { key: 'email', sortable: true },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
        {
          key: 'lastLogin',
          getter: (v) => (
            v ? moment(v).format('LLL') : ''
          ),
        },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
);

export default ListAdmins;
